<template>
  <div class="main-menu">
    <div v-for="(item, i) in items" :key="i" @click="getRoute(item.path)" class="button-main"  @mouseover="item.active = true" @mouseleave="item.active = false">
      <div class="button-image" :class="[item.icon, item.active ? 'hover-img': '']"></div>
      <div class="button-text" :class="{hover: item.active }">{{item.name}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "MainMenu",
    created() {
        if (this.$store.state.schemeType === 0) {
          this.items.splice(2,1)
      }
    },
    methods: {
      getRoute: function (path) {
        this.$router.push(
            {
              path: path,
            }
        )
      }
    },
    data() {
      return {

        items: [
          {
           name: "ОБІГ ПО КЛІЄНТУ",
           active: false,
           icon: "trans",
           path: "/service-results",
          },
          {
            name: "СТАН ЛІМІТІВ",
            active: false,
            icon: "limits",
            path: "/limits",
          },
          {
            name: "ЕЛЕКТРОННИЙ ГАМАНЕЦЬ",
            active: false,
            icon: "wallets",
            path: "/",
          },
          {
            name: "АНАЛІТикА",
            active: false,
            icon: "analytics",
            path: "/analytics",
          },
          {
            name: "МАПА",
            active: false,
            icon: "maps",
            path: "/maps",
          },
          {
            name: "Документообіг",
            active: false,
            icon: "docs",
            path: "/docs",
          }
        ]
      }
    }
  }
</script>
<style>
.main-menu {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 80%; /*1139px;*/
  justify-content: space-between;
}
.button-main {
  width: 165px;
  height: 188px;
  //margin-right: 30px;
  margin-bottom: 75px;
  cursor: pointer;
}
.button-text.hover {
  color: var(--soft-purple);
}
.hover-img {
  background-color: var(--soft-purple) !important;
}
.button-image {
  width: 165px;
  height: 165px;
}

.trans {
  background: url(../assets/trans.png);
  background-size: contain;
  background-color: var(--general-green);
}
.limits {
  background: url(../assets/limits.png);
  background-size: contain;
  background-color:  var(--general-green);
}
.wallets {
  background: url(../assets/wallets.png);
  background-size: contain;
  background-color:  var(--general-green);
}
.analytics {
  background: url(../assets/analytics.png);
  background-size: contain;
  background-color:  var(--general-green);
}
.maps {
  background: url(../assets/maps.png);
  background-size: contain;
  background-color:  var(--general-green);
}
.docs {
  background: url(../assets/docs.png);
  background-size: contain;
  background-color:  var(--general-green);
}

.button-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 1px;
  /* or 146% */
  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;
  color: var(--main-blue);
  padding-top: 10px;
}
.button-text:hover {
  color: var(--soft-purple);
}
@media  (max-width: 1040px)  and (orientation: portrait) {
  .main-menu {
    display: none;
  }
}
@media ( max-width: 1040px)  and (orientation: landscape) {
  .main-menu {
    display: none;
  }
}
</style>